const sendTrackingData = function (code, data) {
  if (!hoian) {
    console.warn('did not receive hoian instance...')
    return
  }

  let trackingData = data
  if (typeof trackingData === 'object') trackingData = JSON.stringify(trackingData)
  console.log('sending ~ trackingData: ', trackingData)

  try {
    return hoian.signal(code, [{ ot: trackingData }])
  } catch (error) {
    console.warn('sent tracking data fail!')
    return false
  }
}

export default sendTrackingData
